"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    rowspan: "2"
};
const _hoisted_2 = {
    key: 1,
    rowspan: "2"
};
const _hoisted_3 = {
    key: 2,
    rowspan: "2"
};
const _hoisted_4 = {
    key: 3,
    class: "delete-btn-cell",
    rowspan: "2"
};
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "roles-name-cell d-flex flex-center" };
const _hoisted_8 = { key: 2 };
const _hoisted_9 = { key: 3 };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = ["colspan"];
const slotTypesToString_1 = require("../common/slotTypesToString");
const models_1 = require("../js/models");
const GroupRoleIconLg_vue_1 = __importDefault(require("./icons/GroupRoleIconLg.vue"));
const rolesStaffTableTypes_1 = require("./rolesStaffView/rolesStaffTableTypes");
const RoleTimeView_vue_1 = __importDefault(require("../role/components/RoleTimeView.vue"));
const vue_3 = require("vue");
const roleTimeLayout_1 = require("../role/roleTimeLayout");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RolesTable',
    props: {
        roles: {},
        isGroupRoleForm: { type: Boolean },
        useForCreateOrEdit: { type: Boolean },
        branchSettings: {},
        showTimeLine: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const tableHeight = (0, vue_3.ref)(roleTimeLayout_1.ROLE_TABLE_HEIGHT);
        function handleTimelineHeight(timelineHeight) {
            if (timelineHeight === roleTimeLayout_1.CONTAINER_HEIGHT) {
                tableHeight.value = roleTimeLayout_1.ROLE_TABLE_HEIGHT;
                return;
            }
            tableHeight.value = roleTimeLayout_1.ROLE_TABLE_HEIGHT + (timelineHeight - roleTimeLayout_1.CONTAINER_HEIGHT);
        }
        function getTimelineColspan() {
            if (props.useForCreateOrEdit) {
                return 10;
            }
            if (props.isGroupRoleForm) {
                return 14;
            }
            return 13;
        }
        function roleColor(role) {
            const s = {
                backgroundColor: `#${role.color}`,
                color: '',
            };
            if (role.color && role.color !== models_1.OPLUS_COLOR_PALETTE.DEFAULT && role.color !== "none") {
                s.color = "#fff";
            }
            return s;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: "oplus-table-wrapper",
                style: (0, vue_2.normalizeStyle)({ height: __props.showTimeLine ? `${tableHeight.value}px` : '' })
            }, [
                (0, vue_2.createElementVNode)("table", {
                    class: (0, vue_2.normalizeClass)(["oplus-table", { 'has-timeline': __props.showTimeLine }])
                }, [
                    (0, vue_2.createElementVNode)("thead", null, [
                        (0, vue_2.createElementVNode)("tr", null, [
                            (!__props.isGroupRoleForm && !__props.useForCreateOrEdit)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_1, "並替"))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (!__props.useForCreateOrEdit)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_2, "編集"))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            _cache[0] || (_cache[0] = (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "業務名", -1 /* CACHED */)),
                            (!__props.useForCreateOrEdit && __props.isGroupRoleForm)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_3, "使用中の拠点数"))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "シフト", -1 /* CACHED */)),
                            _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "休憩時間", -1 /* CACHED */)),
                            _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "説明", -1 /* CACHED */)),
                            _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "時給", -1 /* CACHED */)),
                            _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "割り当て方法", -1 /* CACHED */)),
                            _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "種類", -1 /* CACHED */)),
                            _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "次の日休み", -1 /* CACHED */)),
                            _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("th", {
                                class: "shift-type-header",
                                colspan: "2"
                            }, [
                                (0, vue_2.createElementVNode)("span", null, "シフト表に表示")
                            ], -1 /* CACHED */)),
                            (!__props.useForCreateOrEdit)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_4))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ]),
                        _cache[9] || (_cache[9] = (0, vue_2.createElementVNode)("tr", null, [
                            (0, vue_2.createElementVNode)("th", { class: "role-count-cell" }, [
                                (0, vue_2.createElementVNode)("span", null, "カウント")
                            ]),
                            (0, vue_2.createElementVNode)("th", null, [
                                (0, vue_2.createElementVNode)("span", null, "割当")
                            ])
                        ], -1 /* CACHED */))
                    ]),
                    (0, vue_2.createElementVNode)("tbody", null, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.roles, (role) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                key: role.id
                            }, [
                                (!__props.useForCreateOrEdit)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_5, [
                                        (0, vue_2.createCommentVNode)(" Sort Icon ")
                                    ]))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (!__props.useForCreateOrEdit)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_6, [
                                        (0, vue_2.createCommentVNode)(" Edit Icon ")
                                    ]))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("td", null, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                        (role.isGroupWide)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(GroupRoleIconLg_vue_1.default, { key: 0 }))
                                            : (0, vue_2.createCommentVNode)("v-if", true),
                                        (0, vue_2.createElementVNode)("span", {
                                            class: "role-name",
                                            style: (0, vue_2.normalizeStyle)(roleColor(role))
                                        }, (0, vue_2.toDisplayString)(role.name || "業務名"), 5 /* TEXT, STYLE */)
                                    ])
                                ]),
                                (!__props.useForCreateOrEdit && __props.isGroupRoleForm)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_8, [
                                        (0, vue_2.createCommentVNode)(" Active branch count ")
                                    ]))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(role.from) + " ~ " + (0, vue_2.toDisplayString)(role.to), 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(role.rest || "0:00"), 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(role.purpose || "無"), 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(role.wage || 0), 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_TEXT)[role?.type || 0]), 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(slotTypesToString_1.slotTypeString)[role?.slotType || 0]), 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("td", null, [
                                    (0, vue_2.createElementVNode)("i", {
                                        class: (0, vue_2.normalizeClass)(["zmdi zmdi-hc-lg", role.nextDayOff ? 'zmdi-check role-check-color' : 'zmdi-close'])
                                    }, null, 2 /* CLASS */)
                                ]),
                                (0, vue_2.createElementVNode)("td", null, [
                                    (0, vue_2.createElementVNode)("i", {
                                        class: (0, vue_2.normalizeClass)(["zmdi zmdi-hc-lg", role.showCount ? 'zmdi-check role-check-color' : 'zmdi-close'])
                                    }, null, 2 /* CLASS */)
                                ]),
                                (0, vue_2.createElementVNode)("td", null, [
                                    (0, vue_2.createElementVNode)("i", {
                                        class: (0, vue_2.normalizeClass)(["zmdi zmdi-hc-lg", role.showStaffCount ? 'zmdi-check role-check-color' : 'zmdi-close'])
                                    }, null, 2 /* CLASS */)
                                ]),
                                (!__props.useForCreateOrEdit)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_9, [
                                        (0, vue_2.createCommentVNode)(" Delete button ")
                                    ]))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */)),
                        (__props.showTimeLine && __props.branchSettings && __props.roles[0])
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", _hoisted_10, [
                                (0, vue_2.createElementVNode)("td", {
                                    colspan: getTimelineColspan()
                                }, [
                                    (0, vue_2.createVNode)(RoleTimeView_vue_1.default, {
                                        role: __props.roles[0],
                                        "branch-settings": __props.branchSettings,
                                        onTimelineHeight: handleTimelineHeight
                                    }, null, 8 /* PROPS */, ["role", "branch-settings"])
                                ], 8 /* PROPS */, _hoisted_11)
                            ]))
                            : (0, vue_2.createCommentVNode)("v-if", true)
                    ])
                ], 2 /* CLASS */)
            ], 4 /* STYLE */));
        };
    }
});
